'use client';

import { useState, useEffect } from 'react';


export default function HeroSection() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Cinematic Background Image */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black z-10" />
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_15b0a4555-1767087501347.png"
          alt="Auto exótico de lujo con acabado brillante"
          className="w-full h-full object-cover opacity-50" />

      </div>

      {/* Content */}
      <div className="relative z-20 max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
        {/* Main Headline */}
        <h1 className="font-heading text-6xl md:text-8xl lg:text-[10rem] text-white mb-6 tracking-tighter leading-none">
          ESCUDO <span className="text-[#E60000] italic">TOTAL</span>
        </h1>

        {/* Subheadline */}
        <p className="text-white/80 text-xs md:text-sm lg:text-base font-light tracking-[0.8em] mb-12 uppercase">
          SANTIAGO, RD — LEAF SOLUTIONS PROTECTION
        </p>

        {/* CTA Button */}
        <button
          onClick={() => scrollToSection('servicios')}
          className="inline-flex items-center gap-3 bg-transparent border-2 border-white/30 hover:bg-white hover:text-black text-white px-12 py-5 rounded-none font-heading text-xs tracking-[0.3em] transition-all duration-500 uppercase">

          EXPLORAR SERVICIOS
        </button>
      </div>

      {/* Decorative Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent z-10" />
    </section>);

}